// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__92sls","title":"styles_title__eOKTX"};